<template>
  <div>
    <div class>
      <h1 class="title has-text-centered">{{ article.title }}</h1>
      <div class="columns is-gapless">
        <div class="column is-2"></div>
        <div class="column">
          <p class="content">{{ article.description }}</p>
        </div>
        <div class="column is-2"></div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-2"></div>

      <div class="column">
        <div v-for="(item, index) in items" :key="item.slug">
          <h2 class="title has-text-centered order-number">{{index + 1}}.</h2>
          <vertical-card :ranking="true" :item="item" />
        </div>
      </div>
      <div class="column is-2"></div>
    </div>
    <div class="columns">
      <div class="column"></div>
      <div class="column">
        <span>Podziel się ze znajomymi!</span>
        <social-share-buttons
          class="is-centered"
          :title="article.title"
          :url="'https://nacocito.pl/artykul/' + article.slug + '/'"
        ></social-share-buttons>
      </div>
      <div class="column"></div>
    </div>
    <hr />
    <articles-teaser :limit="4" />

    <hr />
  </div>
</template>

<script>
import articles from "../articles.json";
import database from "../database.json";
import SocialShareButtons from "./SocialShareButtons";
import VerticalCard from "./VerticalCard";
import ArticlesTeaser from "./ArticlesTeaser";

export default {
  name: "Article",
  components: { VerticalCard, SocialShareButtons, ArticlesTeaser },
  data() {
    return {
      article: null,
      articles,
      database: database,
      items: [],
    };
  },
  metaInfo() {
    return {
      meta: [
        // general
        { name: "description", content: this.metaDescription },

        // Schema.org for Google
        { itemprop: "name", content: this.metaTitle },
        { itemprop: "description", content: this.metaDescription },
        { itemprop: "image", content: this.metaImageSrc },

        // twitter
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: this.metaTitle },
        { name: "twitter:description", content: this.metaDescription },
        { name: "twitter:image:src", content: this.metaImageSrc },

        // Open Graph general (Facebook, Pinterest & Google+)
        { property: "og:title", content: this.metaTitle },
        { property: "og:description", content: this.metaDescription },
        { property: "og:image", content: this.metaImageSrc },
        { property: "og:image:url", content: this.metaImageSrc },
        { property: "og:image:width", content: 650 * 2 },
        { property: "og:image:height", content: 341 * 2 },

        { property: "og:image:alt", content: this.metaTitle },
        { property: "og:url", content: this.metaUrlContent },
        { property: "og:locale", content: "pl_PL" },
        { property: "og:type", content: "link" },
      ],
      title: this.metaTitle,
      description: this.metaDescription,
      titleTemplate: "NA CO CI TO? - %s",
    };
  },
  computed: {
    metaImageSrc() {
      return this.article.image_src_jpg;
    },
    metaTitle() {
      return this.article.title;
    },
    metaDescription() {
      return this.article.description;
    },
    metaUrlContent() {
      return `https://nacocito.pl/artykul/${this.article.slug}/`;
    },
  },
  beforeMount() {
    for (let article of this.articles) {
      if (article.slug == this.$route.params.slug) {
        this.article = article;
        break;
      }
    }
    for (let i in this.article.items) {
      let slug = this.article.items[i];
      this.$set(
        this.items,
        i,
        this.database.find((item) => item.slug == slug)
      );
    }
  },
};
</script>

<style>
.order-number {
  margin-top: 2.25rem;
  margin-bottom: 1rem !important;
}
</style>
